import { Product } from '../../../../catalog/products/product';
import { ComplexBase } from '../../../catalog/products/equipement/complex';
import { EdpBase } from '../../../catalog/products/subscription/edp';
import { PlanBase } from '../../../catalog/products/subscription/plan';
import { SchemeBase } from '../scheme.class';

export class RulesBase {
    public KEY: string = 'default';

    constructor(public scheme: SchemeBase) {}

    /**
     * Return all product in conflict with prodct adding
     * @param scheme
     * @param product
     * @return
     */
    public getConflictProject(scheme: SchemeBase, product: Product): Product[] {
        const productsConflict: Product[] = [];
        // Double plan
        if (product instanceof PlanBase) {
            const plan: Product = scheme.getProductByType(PlanBase);
            if (plan) {
                productsConflict.push(plan);
            }
        }

        // Double ComplexBase
        if (product instanceof ComplexBase) {
            const complex: Product = scheme.getProductByType(ComplexBase);
            if (complex) {
                productsConflict.push(complex);
            }
        }
        // Double EdpBase
        if (product instanceof EdpBase) {
            const edp: Product = scheme.getProductByType(EdpBase);
            if (edp) {
                productsConflict.push(edp);
            }
        }

        return productsConflict;
    }

    public isValid(): string[] {
        return [];
    }
}
